export const RATES_FEEDBACK_CATEGORY = {
  RACK_RATE: 'rack_rate',
  NET_RATE: 'net_rate',
  SPECIAL_DISCOUNT: 'special_discount',
  INCLUSIONS: 'inclusions',
  ROUTING: 'routing',
  CHILD_AGE_POLICY: 'child_age_policy',
  ROOM_CAPACITY: 'room_capacity',
  OTHER: 'other',
};

export const RATES_FEEDBACK_CATEGORY_OPTIONS = [
  { label: 'Rack Rate', value: RATES_FEEDBACK_CATEGORY.RACK_RATE },
  { label: 'Net Rate', value: RATES_FEEDBACK_CATEGORY.NET_RATE },
  { label: 'Special/Discount', value: RATES_FEEDBACK_CATEGORY.SPECIAL_DISCOUNT },
  { label: 'Inclusions', value: RATES_FEEDBACK_CATEGORY.INCLUSIONS },
  { label: 'Routing', value: RATES_FEEDBACK_CATEGORY.ROUTING },
  { label: 'Child Age Policy', value: RATES_FEEDBACK_CATEGORY.CHILD_AGE_POLICY },
  { label: 'Room Capacity', value: RATES_FEEDBACK_CATEGORY.ROOM_CAPACITY },
  { label: 'Other', value: RATES_FEEDBACK_CATEGORY.OTHER },
];

export const RATES_FEEDBACK_CATEGORY_VALUES = Object.values(RATES_FEEDBACK_CATEGORY);

export const RATES_FEEDBACK_CATEGORY_LABELS = RATES_FEEDBACK_CATEGORY_OPTIONS.map(opt => opt.label);

export const isValidRatesFeedbackCategory = category =>
  RATES_FEEDBACK_CATEGORY_VALUES.includes(category) || RATES_FEEDBACK_CATEGORY_LABELS.includes(category);
